import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import NoResultsFoundImg from "../../../assets/images/No-resultz-Found.png";
import { showToast } from "../../../components/ToastMsg";
import { useSSR, useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleCheck, faRefresh, faTrashCan, faWallet, faXmark, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { cancelWithrawalRequest, getAllWalletRequests, getAllWalletTransactions, getWalletDetailsByUser, submitWithrawalRequest } from "../../../redux/features/wallet/walletServices";
import WebxpayDepositWallet from "../WebxpayDepositWallet/WebxpayDepositWallet";
import BeatLoader from "react-spinners/BeatLoader";
import DropdownwithValue from "../../../components/DropdownValue";
import Modal from "../../../components/Modal";
import { setShouldRefreshWallet } from "../../../redux/features/wallet/walletSlice";

function formatDate(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date)) return null; // invalid date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const columns = ['Date', 'Operation Type', 'Transaction Type', 'Amount'];

const TableLoading = () => {
    const { t } = useTranslation();
    return (
        <div className={`table-container`}>
            <table className={`table ${styles.tranactionsTable}`}>
                <thead className={`thead ${styles.tranactionsTableHeader}`}>
                    <tr>
                        <th className={`theadColumnOne ${styles.colOne}`}>{t(`Date`)}</th>
                        <th>{t(`Operation`)}</th>
                        <th>{t(`Transaction Type`)}</th>
                        <th>{t(`Amount`)}</th>
                    </tr>
                </thead>
                <tbody className={`tbody ${styles.tranactionsTbBody}`}>
                    {Array.from({ length: 5 }).map((_, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((_, colIndex) => (
                                <td key={colIndex} className={`colIndex === 0 && tdataColumnOne`}>
                                    <Skeleton
                                        height={20}
                                        baseColor="var(--manatee)"
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

const OperationTypes = [
    { id: "Win", name: "Win" },
    { id: "Deposit", name: "Deposit" },
    { id: "Ticket_Buy", name: "Ticket Buy" },
    { id: "Withdrawal", name: "Withdrawal" },
];

const Status = [
    { id: "Credit", name: "Credit" },
    { id: "Debit", name: "Debit" },
];
const Wallet = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const operationDropdownRef = useRef();
    const transactionDropdownRef = useRef();

    const { isLoading, walletDetails } = useSelector((state) => state.wallet.walletDetails);
    const { wallet, shouldRefreshWallet } = useSelector((state) => state.wallet);
    const { isRequesting } = useSelector((state) => state.wallet.withdrawalRequest);
    const { isLoadingTransactions, transactions } = useSelector((state) => state.wallet.walletTransactions);
    const { isLoadingRequests, requestList } = useSelector((state) => state.wallet.walletRequests);
    const { isCancelling } = useSelector((state) => state.wallet.cancelWithdrawalRequest);

    const [isDepositOpen, setDepositOpen] = useState(false);
    const [isWithdrawalOpen, setWithdrawalOpen] = useState(false);
    const [depositData, setDepositData] = useState({});
    const [depositErrors, setDepositErrors] = useState({});

    const [withdrawalData, setWithdrawalData] = useState({});
    const [withdrawalErrors, setWithdrawalErrors] = useState({});
    const [transactionType, setTransactionType] = useState({
        id: null,
        name: null
    });
    const [operationType, setOperationType] = useState({
        id: null,
        name: null
    });
    const [activeTab, setActiveTab] = useState("transactions");
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRequest, setSelectedrequest] = useState(null);
    const [responseError, setResponseError] = useState(null);
    const [isOpen, setOpen] = useState(false);
    const [isFiledOpen, setFailedOpen] = useState(false);

    useEffect(() => {
        dispatch(getWalletDetailsByUser());
    }, [dispatch]);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const statusCode = queryParams.get("status_code");
        const message = queryParams.get("message");
        if (statusCode === '1') {
            setOpen(true);
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            const url = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, url);
        }, 3000); // 3000ms = 3 seconds

        return () => clearTimeout(timer); // cleanup if component unmounts
    }, []);

    const fetchTransactions = useCallback(
        (filters = {}) => {
            const params = {
                skip: 1,
                wallet_transaction_type: transactionType && transactionType.name,
                wallet_operation_type: operationType && operationType.name,
                limit: 12,
                status: true,
                ...filters,
            };
            dispatch(getAllWalletTransactions(params));
        },
        [dispatch, operationType, transactionType]
    );

    const fetchRequests = useCallback(
        (filters = {}) => {
            const params = {
                skip: 1,
                limit: 12,
                status: true,
                ...filters,
            };
            dispatch(getAllWalletRequests(params));
        },
        [dispatch]
    );
    useEffect(() => {
        fetchTransactions();
        fetchRequests();
    }, [fetchTransactions, fetchRequests]);

    const handleSetErrorsFromChild = (errors) => {
        setDepositErrors(errors);
    };

    const validateRequest = () => {
        let errors = {};
        if (!withdrawalData.amount || withdrawalData.amount.trim() === "") {
            errors.amount = "Amount is required.";
        } else if (isNaN(withdrawalData.amount)) {
            errors.amount = "Amount must be a number.";
        } else if (parseFloat(withdrawalData.amount) <= 0) {
            errors.amount = "Amount must be greater than 0.";
        } else if (parseFloat(withdrawalData.amount) < 40) {
            errors.amount = "Minimum deposit is 40.";
        } else if (wallet?.balance < withdrawalData.amount) {
            errors.amount = "Wallet balance is not sufficient.";
        }
        if (!withdrawalData.bank_name) {
            errors.bank_name = "Bank name is required."
        }
        if (!withdrawalData.branch) {
            errors.branch = "Branch is required."
        }
        if (!withdrawalData.account_holder_name) {
            errors.account_holder_name = "Account holder's name is required."
        }
        if (!withdrawalData.account_number) {
            errors.account_number = "Account number is required."
        }
        if (Object.keys(errors).length > 0) {
            setWithdrawalErrors(errors);
            return false;
        } else {
            return true;
        }
    }
    const submitRequest = async () => {
        setResponseError(null);
        if (validateRequest()) {
            try {
                withdrawalData.currency = 'LKR';
                withdrawalData.amount = +withdrawalData.amount;
                const response = await dispatch(submitWithrawalRequest(withdrawalData)).unwrap();
                if (response.success === true) {
                    setWithdrawalOpen(false);
                    fetchRequests();
                    dispatch(setShouldRefreshWallet(true));
                    showToast('success', response.message);
                    setWithdrawalData({});
                }
            } catch (error) {
                setResponseError(error);
            }
        }
    };

    const selectOperationTypes = (option) => {
        setOperationType({ id: option.id, name: option.name });
    }

    const selectTransactionType = (option) => {
        setTransactionType({ id: option.id, name: option.name });
    }

    const handleReset = (tab) => {
        operationDropdownRef.current.value = '';
        transactionDropdownRef.current.value = '';
        setOperationType({ id: null, name: null });
        setTransactionType({ id: null, name: null });
    }

    const removeRequest = async () => {
        try {
            const data = {
                id: selectedRequest,
                status: false
            }
            setModalOpen(false);
            const response = await dispatch(cancelWithrawalRequest(data)).unwrap();
            if (response.success === true) {
                fetchRequests();
                dispatch(setShouldRefreshWallet(true));
                showToast('success', response.message);
            } else {
                showToast('error', response.message);
            }
        } catch (error) {
            showToast('error', error.message);
        }
    }
    return (
        <>
            <div className={styles.walletContainer}>
                <div className="main-container">
                    <div className={`container-content ${styles.cartCard}`}>
                        {isLoading ?
                            <>
                                <div className={styles.walletBody}>
                                    <div className={styles.walletSec}>
                                        <div className={styles.walletBodyLeft}>
                                            <div className={styles.bodyTop}>
                                                <div>
                                                    <Skeleton width={100} className={styles.nameTag} style={{ marginBottom: '10px' }} />
                                                    <Skeleton height={30} width={200} className={styles.nameValue} />
                                                    <Skeleton width={100} className={styles.nameTag} />
                                                    <Skeleton height={30} width={200} className={styles.nameValue} />
                                                </div>
                                                <Skeleton className={styles.cardIcon} />
                                            </div>
                                            <div className={styles.skeletonCardBottom}>
                                                <Skeleton width={100} className={styles.balanceText} />
                                                <Skeleton height={30} width={150} className={styles.balance} />
                                            </div>
                                        </div>
                                        <div className={styles.walletbtns}>
                                            <div className={styles.depositBtn}>Deposit</div>
                                            <div className={styles.withdrawalBtn}>Withdrawal</div>
                                        </div>
                                    </div>
                                    <div className={styles.walletFooter}>
                                        <TableLoading />
                                    </div>
                                </div>
                            </>
                            : walletDetails ?
                                <>
                                    <div className={styles.walletBody}>
                                        {i18n.language === 'si'?
                                            <div className={styles.walletSec}>
                                                <div className={styles.walletBodyLeft}>
                                                    <div className={styles.bodyTop}>
                                                        <div>
                                                            <p className={styles.nameTag}>සම්පූර්ණ නම</p>
                                                            <p className={styles.nameValue}>{walletDetails?.user?.full_name}</p>
                                                            <p className={styles.nameTag}>පරිශීලක නාමය</p>
                                                            <p className={styles.nameValue}>{walletDetails?.user?.username}</p>
                                                        </div>
                                                        <FontAwesomeIcon icon={faWallet} className={styles.cardIcon} />
                                                    </div>
                                                    <p className={styles.balanceText}>ශේෂය</p>
                                                    <p className={styles.balance}>{wallet?.balance !== null ? wallet?.balance.toFixed(2) : '0.00'}</p>
                                                </div>
                                                <div className={styles.walletbtns}>
                                                    <div className={styles.depositBtn} onClick={() => setDepositOpen(true)}>තැන්පත් කරන්න</div>
                                                    <div className={styles.withdrawalBtn} onClick={() => setWithdrawalOpen(true)}>ආපසු ගැනීම</div>
                                                </div>
                                            </div>
                                        :
                                        i18n.language === 'ta' ?
                                            <div className={styles.walletSec}>
                                                <div className={styles.walletBodyLeft}>
                                                    <div className={styles.bodyTop}>
                                                        <div>
                                                            <p className={styles.nameTag}>முழு பெயர்</p>
                                                            <p className={styles.nameValue}>{walletDetails?.user?.full_name}</p>
                                                            <p className={styles.nameTag}>பயனர் பெயர்</p>
                                                            <p className={styles.nameValue}>{walletDetails?.user?.username}</p>
                                                        </div>
                                                        <FontAwesomeIcon icon={faWallet} className={styles.cardIcon} />
                                                    </div>
                                                    <p className={styles.balanceText}>சமநிலை</p>
                                                    <p className={styles.balance}>{wallet?.balance !== null ? wallet?.balance.toFixed(2) : '0.00'}</p>
                                                </div>
                                                <div className={styles.walletbtns}>
                                                    <div className={styles.depositBtn} onClick={() => setDepositOpen(true)}>வைப்பு</div>
                                                    <div className={styles.withdrawalBtn} onClick={() => setWithdrawalOpen(true)}>திரும்பப் பெறுதல்</div>
                                                </div>
                                            </div>
                                        :
                                           <div className={styles.walletSec}>
                                                <div className={styles.walletBodyLeft}>
                                                    <div className={styles.bodyTop}>
                                                        <div>
                                                            <p className={styles.nameTag}>Full Name</p>
                                                            <p className={styles.nameValue}>{walletDetails?.user?.full_name}</p>
                                                            <p className={styles.nameTag}>Username</p>
                                                            <p className={styles.nameValue}>{walletDetails?.user?.username}</p>
                                                        </div>
                                                        <FontAwesomeIcon icon={faWallet} className={styles.cardIcon} />
                                                    </div>
                                                    <p className={styles.balanceText}>Balance</p>
                                                    <p className={styles.balance}>{wallet?.balance !== null ? wallet?.balance.toFixed(2) : '0.00'}</p>
                                                </div>
                                                <div className={styles.walletbtns}>
                                                    <div className={styles.depositBtn} onClick={() => setDepositOpen(true)}>Deposit</div>
                                                    <div className={styles.withdrawalBtn} onClick={() => setWithdrawalOpen(true)}>Withdrawal</div>
                                                </div>
                                            </div>}
                                        <div className={styles.walletFooter}>
                                            {activeTab === 'transactions' &&
                                                <>
                                                    <div className={styles.filterBtn}>
                                                        <div className={styles.filterSec}>
                                                            <DropdownwithValue
                                                                ref={operationDropdownRef}
                                                                options={OperationTypes}
                                                                placeholder='Select Type'
                                                                onSelect={selectOperationTypes}
                                                                value={operationType.name}
                                                            />
                                                            <DropdownwithValue
                                                                ref={transactionDropdownRef}
                                                                options={Status}
                                                                placeholder='Select Status'
                                                                onSelect={selectTransactionType}
                                                                value={transactionType.name}
                                                            />
                                                            {i18n.language === 'en' &&
                                                                <button
                                                                    type="button"
                                                                    className={`${styles.resetBtn} ${styles.webBtn}`}
                                                                    onClick={() => handleReset(activeTab)}
                                                                >
                                                                    Reset
                                                                </button>
                                                            }
                                                            {i18n.language !== 'en' &&
                                                                <button
                                                                    type="button"
                                                                    className={`${styles.resetBtn} ${styles.webBtn}`}
                                                                    onClick={() => handleReset(activeTab)}
                                                                >

                                                                    <FontAwesomeIcon icon={faRefresh} />
                                                                </button>
                                                            }
                                                            <button
                                                                type="button"
                                                                className={`${styles.mobileBtn}`}
                                                                onClick={() => handleReset(activeTab)}
                                                            >
                                                                <FontAwesomeIcon icon={faRefresh} />
                                                            </button>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className={`${styles.resetBtn} ${styles.webBtn}`}
                                                            onClick={() => setActiveTab('requests')}
                                                        >
                                                            {t(`Withdrawal Request`)}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={styles.mobileBtn}
                                                            onClick={() => setActiveTab('requests')}
                                                        >
                                                            {t(`Request`)}
                                                        </button>
                                                    </div>
                                                    {isLoadingTransactions ?
                                                        <TableLoading />
                                                        :
                                                        (transactions?.data?.length > 0 ?
                                                            <div className={`table-container`}>
                                                                <table className={`table ${styles.tranactionsTable}`}>
                                                                    <thead className={`thead ${styles.tranactionsTableHeader}`}>
                                                                        <tr>
                                                                            <th className={`theadColumnOne ${styles.colOne}`}>{t(`Date`)}</th>
                                                                            <th>{t(`Operation`)}</th>
                                                                            <th>{t(`Transaction`)}</th>
                                                                            <th>{t(`Amount`)}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className={`tbody ${styles.tranactionsTbBody}`}>
                                                                        {transactions?.data?.map((transaction) => (
                                                                            <tr key={transaction.id}>
                                                                                <td className={`tdataColumnOne`}>
                                                                                    {formatDate(transaction.created_at)}
                                                                                </td>
                                                                                <td>{transaction.wallet_operation_type}</td>
                                                                                <td>{transaction.wallet_transaction_type}</td>
                                                                                <td>{transaction.amount.toFixed(2)}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            :
                                                            <div className={styles.noResults}>
                                                                <img
                                                                    src={NoResultsFoundImg}
                                                                    alt="No Results Found"
                                                                    className={styles.noResultsImage}
                                                                />
                                                            </div>
                                                        )}
                                                </>
                                            }
                                            {activeTab === 'requests' &&
                                                <>
                                                    <div className={styles.filterBtn}>
                                                        <div className={styles.filterSec}>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className={`${styles.resetBtn} ${styles.transBtn}`}
                                                            onClick={() => setActiveTab('transactions')}
                                                        >
                                                            {t(`Transactions`)}
                                                        </button>
                                                    </div>
                                                    {isLoadingRequests ?
                                                        <TableLoading />
                                                        :
                                                        (requestList?.data?.length > 0 ?
                                                            <div className={`table-container`}>
                                                                <table className={`table ${styles.tranactionsTable}`}>
                                                                    <thead className={`thead ${styles.tranactionsTableHeader}`}>
                                                                        <tr>
                                                                            <th className={`theadColumnOne ${styles.colOne}`}>{t(`Date`)}</th>
                                                                            <th>{t(`Bank`)}</th>
                                                                            <th>{t(`Account Number`)}</th>
                                                                            <th>{t(`Status`)}</th>
                                                                            <th>{t(`Amount`)}</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className={`tbody ${styles.tranactionsTbBody}`}>
                                                                        {requestList?.data?.map((request) => (
                                                                            <tr key={request.id}>
                                                                                <td className={`tdataColumnOne`}>
                                                                                    {formatDate(request.created_at)}
                                                                                </td>
                                                                                <td>{request.bank_name}</td>
                                                                                <td>{request.account_number}</td>
                                                                                <td>{request.withdrawal_request_status}</td>
                                                                                <td>{request.amount.toFixed(2)}</td>
                                                                                <td>
                                                                                    {request.withdrawal_request_status === 'Pending' &&
                                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => { setModalOpen(true); setSelectedrequest(request.id) }} />
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            :
                                                            <div className={styles.noResults}>
                                                                <img
                                                                    src={NoResultsFoundImg}
                                                                    alt="No Results Found"
                                                                    className={styles.noResultsImage}
                                                                />
                                                            </div>
                                                        )}
                                                </>
                                            }
                                        </div>
                                    </div>
                                </>
                                :
                                <div className={styles.emptyImg}>
                                    <img
                                        src={NoResultsFoundImg}
                                        alt="No Results Found"
                                        className={styles.noResultsImage}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
            {isDepositOpen &&
                <>
                    <div className={`main-container`}>
                        <div className={styles.walletModal}>
                            <div className={styles.walletModalContainer}>
                                <div className={styles.closeRow}>
                                    <p className={styles.walletTitle}>Deposit to Wallet</p>
                                    <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                        setDepositOpen(false);
                                        document.body.style.overflow = 'unset';
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                        setDepositErrors('');
                                        setDepositData('');
                                    }} />
                                </div>
                                <div className={styles.walletModalBody}>
                                    <div className={`form-input-row`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='amount' className={`form-label`}>
                                                Amount{" "}
                                                <span className={styles.note}>(Minimum amount is Rs.40.00 and Maximum amount is Rs.200,000.00)</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='amount'
                                                name='amount'
                                                value={depositData.amount}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) {
                                                        setDepositData({ ...depositData, amount: value });
                                                        setDepositErrors('');
                                                    }
                                                }}
                                                placeholder='Enter the amount'
                                                className={`form-input-default`}
                                            />
                                            {depositErrors.amount && (
                                                <p className={`text-danger`}>{depositErrors.amount}</p>
                                            )}
                                        </div>
                                    </div>
                                    <WebxpayDepositWallet
                                        walletId={walletDetails?.id}
                                        totalAmount={depositData.amount}
                                        onValidationError={handleSetErrorsFromChild} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {isWithdrawalOpen &&
                <>
                    <div className={`main-container`}>
                        <div className={styles.walletModal}>
                            <div className={styles.walletModalContainer}>
                                <div className={styles.closeRow}>
                                    <p className={styles.walletTitle}>Withdrawal Request</p>
                                    <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                        setWithdrawalOpen(false);
                                        document.body.style.overflow = 'unset';
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                        setWithdrawalErrors({});
                                        setWithdrawalData({});
                                        setResponseError(null);
                                    }} />
                                </div>
                                <div className={styles.walletModalBody}>
                                    <div className={`form-input-row`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='amount' className={`form-label`}>
                                                Amount{" "}
                                                <span className={styles.note}>(Minimum amount is Rs.401.00 and Maximum amount is Rs.350,000.00)</span>
                                            </label>
                                            <input
                                                type='text'
                                                id='amount'
                                                name='amount'
                                                value={withdrawalData.amount}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) {
                                                        setWithdrawalData({ ...withdrawalData, amount: value });
                                                        setWithdrawalErrors({ ...withdrawalErrors, amount: '' });
                                                    }
                                                }}
                                                placeholder='Enter the amount'
                                                className={`form-input-default`}
                                            />
                                            {withdrawalErrors.amount && (
                                                <p className={`text-danger`}>{withdrawalErrors.amount}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='amount' className={`form-label`}>
                                                Bank
                                            </label>
                                            <input
                                                type='text'
                                                id='bank_name'
                                                name='bank_name'
                                                value={withdrawalData.bank_name}
                                                onChange={(e) => {
                                                    setWithdrawalData({ ...withdrawalData, bank_name: e.target.value });
                                                    setWithdrawalErrors({ ...withdrawalErrors, bank_name: '' });
                                                }}
                                                placeholder='Enter the bank name'
                                                className={`form-input-default`}
                                            />
                                            {withdrawalErrors.bank_name && (
                                                <p className={`text-danger`}>{withdrawalErrors.bank_name}</p>
                                            )}
                                        </div>
                                        <div className={`form-input-group ${styles.mobileRow}`}>
                                            <label htmlFor='amount' className={`form-label`}>
                                                Branch
                                            </label>
                                            <input
                                                type='text'
                                                id='branch'
                                                name='branch'
                                                value={withdrawalData.branch}
                                                onChange={(e) => {
                                                    setWithdrawalData({ ...withdrawalData, branch: e.target.value });
                                                    setWithdrawalErrors({ ...withdrawalErrors, branch: '' });
                                                }}
                                                placeholder='Enter the branch'
                                                className={`form-input-default`}
                                            />
                                            {withdrawalErrors.branch && (
                                                <p className={`text-danger`}>{withdrawalErrors.branch}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='amount' className={`form-label`}>
                                                Account Holder's Name
                                            </label>
                                            <input
                                                type='text'
                                                id='account_holder_name'
                                                name='account_holder_name'
                                                value={withdrawalData.account_holder_name}
                                                onChange={(e) => {
                                                    setWithdrawalData({ ...withdrawalData, account_holder_name: e.target.value });
                                                    setWithdrawalErrors({ ...withdrawalErrors, account_holder_name: '' });
                                                }}
                                                placeholder='Enter account holder name'
                                                className={`form-input-default`}
                                            />
                                            {withdrawalErrors.account_holder_name && (
                                                <p className={`text-danger`}>{withdrawalErrors.account_holder_name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={`form-input-row`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='amount' className={`form-label`}>
                                                Account Number
                                            </label>
                                            <input
                                                type='text'
                                                id='account_number'
                                                name='account_number'
                                                value={withdrawalData.account_number}
                                                onChange={(e) => {
                                                    setWithdrawalData({ ...withdrawalData, account_number: e.target.value });
                                                    setWithdrawalErrors({ ...withdrawalErrors, account_number: '' });
                                                }}
                                                placeholder='Enter the account number'
                                                className={`form-input-default`}
                                            />
                                            {withdrawalErrors.account_number && (
                                                <p className={`text-danger`}>{withdrawalErrors.account_number}</p>
                                            )}
                                            {responseError &&
                                                <p className={`text-danger`}>{responseError}</p>
                                            }
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className={styles.submitBtn}
                                        onClick={submitRequest}
                                        disabled={isRequesting}>
                                        {isRequesting ? <BeatLoader color='#ffffff' /> : `Submit`}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {modalOpen &&
                <Modal
                    title='Cancel Withdrawal Request'
                    onClose={() => setModalOpen(false)}
                    onYes={removeRequest}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to cancel the selected withdrawal request?`}
                    colorType={`var(--primary)`}
                />
            }
            {isOpen &&
                <>
                    <div className={styles.modal}>
                        <div className={styles.modalContainer}>
                            <div className={styles.closeMsgRow}>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }} />
                            </div>
                            <div className={styles.modalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkIcon} />
                                        <p className={styles.conTitle}>Deposit Succeed</p>
                                        <p className={styles.conText}>Your amount has been successfully deposited to your wallet. <br /> Best of luck!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
              {isFiledOpen &&
                <>
                    <div className={styles.modal}>
                        <div className={styles.modalContainer}>
                            <div className={styles.closeMsgRow}>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setFailedOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }} />
                            </div>
                            <div className={styles.modalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <FontAwesomeIcon icon={faXmarkCircle} className={styles.checkIcon}/>
                                        <p className={styles.conTitle}>Deposit Failed</p>
                                        <p className={styles.conText}>Your deposit is failed to complete.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
};

export default Wallet;